import axios from "axios";

const PRODUCTION_HOST = "node.app.paluzapp.a2hosted.com";
let qaClient;
let qaClientBase;

export function getQaConfiguration() {
  // Keep the existing export for capture/review consumers; the target is no longer QA.
  const raw = axios.defaults?.baseURL;
  try {
    const url = new URL(raw);
    if (!raw || url.protocol !== "https:" || url.hostname !== PRODUCTION_HOST || url.port ||
        url.username || url.password ||
        url.search || url.hash || !["/", "/api", "/api/"].includes(url.pathname)) {
      throw new Error("API URL invalida");
    }
    return { enabled: true, baseURL: `${url.origin}/api` };
  } catch (_) {
    return { enabled: false, reason: "La API productiva de Salud V2 no esta configurada correctamente." };
  }
}

function token() {
  try {
    return JSON.parse(localStorage.getItem("token") || "null")?.idToken || "";
  } catch (_) {
    return "";
  }
}

export function getQaAxiosClient(config = getQaConfiguration()) {
  if (!config.enabled) throw new Error(config.reason);
  if (!qaClient || qaClientBase !== config.baseURL) {
    qaClient = axios.create({ baseURL: config.baseURL, timeout: 30000 });
    qaClientBase = config.baseURL;
  }
  return qaClient;
}

async function request(method, suffix = "", payload, options = {}) {
  const config = getQaConfiguration();
  if (!config.enabled) throw new Error(config.reason);
  const authToken = token();
  if (!authToken) {
    const error = new Error("Sesión vencida. Inicie sesión nuevamente.");
    error.status = 401;
    throw error;
  }
  const headers = { Authorization: `Bearer ${authToken}`, "x-access-token": authToken };
  if (options.idempotencyKey) headers["Idempotency-Key"] = options.idempotencyKey;
  // Reuse the configured destination and session, without changing global Axios/interceptors.
  const client = getQaAxiosClient(config);
  const path = config.baseURL.endsWith("/api") ? "/salud/v2/atenciones" : "/api/salud/v2/atenciones";
  const response = await client.request({ method, url: `${path}${suffix}`, data: payload, params: options.params, headers });
  return method === "post" ? { ...response.data, httpStatus: response.status } : response.data;
}

export const saludV2Client = {
  list: (params) => request("get", "", undefined, { params }),
  get: (uuid) => request("get", `/${encodeURIComponent(uuid)}`),
  create: (body, idempotencyKey) => request("post", "", body, { idempotencyKey }),
  update: (uuid, body) => request("put", `/${encodeURIComponent(uuid)}`, body),
  history: (uuid) => request("get", `/${encodeURIComponent(uuid)}/historial`),
};

export function readableApiError(error) {
  const status = error?.response?.status || error?.status;
  if (status === 401) return "Sesión vencida. Inicie sesión nuevamente.";
  if (status === 403) return "No tiene permiso para esta convocatoria o atención.";
  if (status === 404) return "Convocatoria o atención no encontrada.";
  if (status === 409) return "La atención cambió. Recupere la versión actual antes de guardar.";
  if (status === 400 || status === 422) return error?.response?.data?.error?.message || "Revise los campos informados.";
  if (error?.response?.data?.error?.message) return error.response.data.error.message;
  return error?.message || "Error de red. Conserve los datos y vuelva a intentar.";
}
